import { Component, Input, OnInit } from '@angular/core';
import { BusinessManagerService } from '../user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';
import { FlightbridgeService } from '../services/flightbridge.service';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';

@Component({
  selector: 'app-flightbridge-right-rail',
  templateUrl: './flightbridge-right-rail.component.html',
  styleUrls: ['./flightbridge-right-rail.component.scss']
})
export class FlightbridgeRightRailComponent implements OnInit {
  @Input() airportIdent: string;
  isLoggedIn = false;
  isMember = false;

  constructor(private _businessManagerService: BusinessManagerService,
              private _auth: AuthService,
              private _flightbridgeService: FlightbridgeService,
              private _analyticsService: AnalyticsService) { }

  async ngOnInit() {
    if (this._auth.authenticated && this._auth.endUser) {
      this.isLoggedIn = true;
      this.isMember = await this._businessManagerService.isMember();
    }
  }

  async navigateToFlightBridge(pageType: string) {
    const ssoRetval = await this._flightbridgeService.postFlightBridgeSSOInitial();
    const firstDate = new Date();
    firstDate.setDate(firstDate.getDate() + 1);
    const firstDateString = formatDate(firstDate, 'yyyy-MM-dd', 'en-US');
    const nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + 3);
    const nextDateString = formatDate(nextDate, 'yyyy-MM-dd', 'en-US');
    let URL = '';
    if (pageType === 'hotel') {
      this._analyticsService.trackEvent('airport_flightbridge_hotel', '', '');
      if (this.airportIdent) {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeHotelUrl}&UserAuthenticationToken=${ssoRetval.token}&AirportCode=${this.airportIdent}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
        this._analyticsService.trackEvent('airport_flightbridge_hotel-specific', this.airportIdent, this.airportIdent);
      } else {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeAnywhereHotelUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      }
    } else if (pageType === 'rentalcar') {
      this._analyticsService.trackEvent('airport_flightbridge_rentalcar', '', '');
      if (this.airportIdent) {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeRentalCarUrl}&UserAuthenticationToken=${ssoRetval.token}&AirportCode=${this.airportIdent}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
        this._analyticsService.trackEvent('airport_flightbridge_rentalcar-specific', this.airportIdent, this.airportIdent);
      } else {
        // tslint:disable-next-line:max-line-length
        URL = `${environment.flightBridgeAnywhereRentalCarUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      }
    } else {
      // tslint:disable-next-line:max-line-length
      URL = `${environment.flightBridgeAirlineUrl}&UserAuthenticationToken=${ssoRetval.token}&CheckInDate=${firstDateString}&CheckOutDate=${nextDateString}`;
      this._analyticsService.trackEvent('airport_flightbridge_airline', '', '');
    }
    window.open(URL);
  }

  navigateToJoinAOPA() {
    window.open('https://www.aopa.org/account/multipagejoin');
  }

  navigateToLogin() {
    window.open('https://www.aopa.org/login');
  }
}
